/**
 * hooks/useGoBack.js — «Буцах» товчны нэгдсэн зан төлөв.
 *
 * Асуудал: хуудсууд буцах хаягаа ХАТУУ бичдэг байсан
 * (ж: `navigate("/hazard/dashboard")`). Тиймээс хэрэглэгч аль хуудаснаас
 * ирснээс үл хамааран нэг тогтсон газар руу шиднэ — /me-ээс аюул мэдээлээд
 * буцахад аюулын хянах самбар дээр гарч ирдэг байв.
 *
 * Гурван шатлалт:
 *   1. Дуудагч `state.from` дамжуулсан бол — ТҮҮНИЙ заасан хаяг руу.
 *      (мөн `state.tab` зэрэг нэмэлт утгыг буцааж дамжуулна — /me-ийн таб
 *      сэргээхэд хэрэгтэй)
 *   2. Апп дотор түүх байвал — жинхэнэ өмнөх хуудас руу (`navigate(-1)`).
 *   3. Аль нь ч биш (шууд линкээр орсон, refresh хийсэн) — хуудасны
 *      анхдагч хаяг руу.
 *
 * ⚠ 2-р шатыг `window.history.state?.idx`-ээр шалгана: react-router v6 нь
 * оруулга бүрд `idx` тавьдаг. 0 бол апп дотор өмнөх хуудас БАЙХГҮЙ гэсэн үг —
 * `navigate(-1)` хийвэл хэрэглэгч аппаас гарч оддог.
 *
 * Хэрэглээ:
 *   const goBack = useGoBack("/risk/list");
 *   <Button onClick={goBack}>Буцах</Button>
 */
import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function useGoBack(fallback = "/", { useHistory = true } = {}) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const from = location.state?.from;
    if (from) {
      const { from: _skip, ...rest } = location.state || {};
      navigate(from, {
        state: Object.keys(rest).length ? rest : undefined,
      });
      return;
    }
    // ⚠ `useHistory: false` — түүхийг ашиглахгүй.
    // ЦЭСНЭЭС нээгддэг хуудсанд түүх нь ТААРАМЖГҮЙ: хэрэглэгч огт өөр
    // модулийн хуудас дээр байгаад цэснээс «Аюул бүртгэх» сонговол
    // `navigate(-1)` нь тэр хамааралгүй хуудас руу буцаадаг.
    // Тийм хуудсанд эх хаягийг `state.from`-оор ТОДОРХОЙ дамжуулах ёстой,
    // үгүй бол модулийн үндсэн хуудас (fallback) руу очно.
    const idx = window.history.state?.idx;
    if (useHistory && typeof idx === "number" && idx > 0) {
      navigate(-1);
      return;
    }
    navigate(fallback);
  }, [navigate, location.state, fallback, useHistory]);
}
